exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-0b48f986]{font-size:16px}h2[data-v-0b48f986],ul[data-v-0b48f986]{margin:0;color:#006400}ul[data-v-0b48f986]{padding:0 0 0 1.5em}li[data-v-0b48f986]{margin:1.5em 0;padding:0}b[data-v-0b48f986],li[data-v-0b48f986]{color:#006400}b[data-v-0b48f986]{margin-right:3px}.demo-app[data-v-0b48f986]{min-height:100%;font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-size:14px}.demo-app-main[data-v-0b48f986]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:3em}", ""]);

// exports
